(function () {
  // Varianto pasirinkimas: atnaujina kainą ir mygtuką
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var form = select.closest('form');
    var section = select.closest('.product');
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (!section) return;
      var price = section.querySelector('[data-price]');
      var compare = section.querySelector('[data-compare-price]');
      var button = form ? form.querySelector('[data-add-button]') : null;
      if (price) price.textContent = option.dataset.price;
      if (compare) compare.textContent = option.dataset.compare || '';
      if (button) {
        var available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available ? 'Į krepšelį' : 'Išparduota';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Filtrai ir rikiavimas kolekcijoje: pritaikoma iš karto
  document.querySelectorAll('[data-autosubmit-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      form.submit();
    });
  });
})();
